import React, {Component} from 'react';

import Headline from '../Headline/Headline'
import styles from './ErrorEmptyResult.css'

export default class ErrorEmptyResult extends Component {
    render() {
        const {iframe} = this.props;

        return (
            <div className={styles.container}>
                {
                    iframe && <Headline>Bitte wählen sie einen Behandler.</Headline>
                }
                {
                    !iframe && <Headline>Es wurden leider keine Termine gefunden.</Headline>
                }
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/ErrorEmptyResult/ErrorEmptyResult.js